import Vue from 'vue'
import VueI18n from 'vue-i18n'

import es from 'vuetify/lib/locale/es'
import pt from 'vuetify/lib/locale/pt'

Vue.use(VueI18n)

const messages = {
  pt: {
    ...require('@/locales/pt.json'),
    $vuetify: pt,
  },
  es: {
    ...require('@/locales/es.json'),
    $vuetify: es,
  },
}

export default new VueI18n({
  locale: process.env.VUE_APP_I18N_LOCALE,
  fallbackLocale: process.env.VUE_APP_I18N_LOCALE,
  messages,
  silentTranslationWarn: true,
})

// export default new VueI18n({
//   locale: process.env.VUE_APP_I18N_LOCALE || 'pt',
//   fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'pt',
//   messages,
// })
